module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"allocation_list":"Allocation List"},"si":{"allocation_list":"Allocation List"},"ta":{"allocation_list":"Allocation List"}}')
  delete Component.options._Ctor
}
